module.exports = __webpack_public_path__ + "static/media/pre-approval.08cff4cf.svg";